export default __webpack_public_path__ + "static/media/bell.3a797d97.svg";